// These public assets replaced files previously served with immutable caching.
const imageVersions: Record<string, string> = {
  "/coaches/laura.jpg": "9c2bafc079e2",
  "/coaches/kacheln/laura.jpg": "c565d0f01c3e",
  "/mediathek/hero-laura.jpg": "66584ca4d1a5",
  "/coaches/norbert.jpg": "fdbb07b90148",
  "/coaches/kacheln/norbert.jpg": "202dfb8c3615",
  "/mediathek/hero-norbert.jpg": "40f32340433a",
  "/coaches/lukas.jpg": "0bd62edc4078",
  "/coaches/kacheln/lukas.jpg": "c03085c7f57d",
  "/mediathek/hero-lukas.jpg": "cf6ec53afe28",
}

export function versionedImageUrl(src: string | undefined): string | undefined {
  if (!src) return src
  const version = imageVersions[src]
  return version ? `${src}?v=${version}` : src
}
